import { Box } from '@mui/material';
import { DataCellProps } from '../types';

export const DataDeletionTeamIdCell = ({ team }: DataCellProps) => {
  return <Box>{team.teamId}</Box>;
};
